import { render, staticRenderFns } from "./BasicQuery.vue?vue&type=template&id=46029e8e&scoped=true"
import script from "./BasicQuery.vue?vue&type=script&lang=js"
export * from "./BasicQuery.vue?vue&type=script&lang=js"
import style0 from "./BasicQuery.vue?vue&type=style&index=0&id=46029e8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46029e8e",
  null
  
)

export default component.exports